// ** Reactstrap Imports
import { Card, CardBody, Spinner, Badge, UncontrolledTooltip } from 'reactstrap'
import { getEllipsisTxt  } from '../../helpers/formatters'
import DataTable from 'react-data-table-component'
import useRecentPayoutList from '../../hooks/useRecentPayoutListV2'

export default function RecentRewardsPayoutsList() {

  const columns = [
    {
      name: 'Tnx Hash',
      sortable: false,
      cell: row => (
        <div className='d-flex align-items-center dt-tnx-hash'>
          <a target="_blank" href={`https://bscscan.com/tx/${  row.transactionHash}`} rel="noreferrer">
          { getEllipsisTxt(row.transactionHash, 8)}
          </a>
        </div>
      )
    },
    {
      name: 'Block#',
      sortable: false,
      minWidth: '250px',
      cell: row => (
        <div className='d-flex justify-content-center align-items-center dt-block-no'>
          <a target="_blank" href={`https://bscscan.com/block/${  row.blockNumber}`} rel="noreferrer">
          <Badge color='light-success' pill>
          { row.blockNumber}
          </Badge>
          </a>
        </div>
      )
    },
    {
      name: 'From',
      sortable: false,
      cell: row => (
        <div className='d-flex align-items-center dt-from'>
          <a target="_blank" href={`https://bscscan.com/address/${row.address}`} rel="noreferrer">
          { getEllipsisTxt(row.address, 7)}
          </a>
        </div>
      )
    },
  
    {
      name: 'To',
      sortable: false,
      cell: row => (
        <div className='d-flex align-items-center dt-to'>
          <a target="_blank" href={`https://bscscan.com/address/${row.returnValues.to}`} rel="noreferrer">
          { getEllipsisTxt(row.returnValues.to, 7)}
          </a>
        </div>
      )
    },
    {
      name: 'Payout Value (ETH)',
      sortable: false,
      cell: row => (
        <div className='d-flex align-items-center'>
          <Badge color='light-primary' pill>
          { (row.returnValues.weiAmount / (10 ** 18)).toFixed(6) } ETH
         </Badge>
        </div>
      )
    }
  ]
 
  const {isLoading, recentPayoutList} = useRecentPayoutList()
  return (
    <Card>
      {
        isLoading ? (
        <CardBody className="data-info-widget">
          <Spinner type='grow' color='primary' />
        </CardBody>
        
        ) : (
          <CardBody className="data-info-widget">
            <div className='data-info-widget-title'>
              Recent Dividend Payout List (within last ~4 hours )
            </div>
        
            <div className='recent-payout-list-table'>
              <DataTable
                noHeader
                pagination
                data={recentPayoutList}
                columns={columns}
                className='recent-payout-list-table'
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                customStyles={{}}
              />
            </div>
      </CardBody>
        )
      }
      
    </Card>
  )
}
